var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.itemid
    ? _c(
        "section",
        { staticClass: "header-region", class: _vm.headerClasses },
        [
          _c(
            "div",
            {
              staticClass: "header-content-position",
              class: { "content-gradient": _vm.hasImage },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "header-content" },
                      [
                        _c("div", { staticClass: "header-title" }, [
                          _c("h1", [_vm._v(_vm._s(_vm.title))]),
                        ]),
                        _vm._v(" "),
                        _vm.item
                          ? [
                              _vm.headerContent
                                ? _c("div", {
                                    staticClass: "header-description",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.headerContent),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.headerLinks
                                ? _c(
                                    "div",
                                    { staticClass: "header-links" },
                                    [
                                      _vm._l(
                                        _vm.headerLinks,
                                        function (link, key) {
                                          return [
                                            _c(
                                              "generic-link",
                                              {
                                                key: key,
                                                staticClass: "btn btn-primary",
                                                class: key,
                                                attrs: { href: `${link.url}` },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getLinkTitle(link)
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.hasImage
            ? _c("AImage", {
                attrs: {
                  img: _vm.headerImage,
                  responsive: "",
                  preset: "banner",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }